/* eslint-disable prettier/prettier */
import { Config } from './config/index.js';

const interOP = (fn, name) => () => fn().then(mod => mod[name]);

const UseCases = {
  /* Alert */
  AddClosedAlertIDUseCase: interOP(() => import(
  /* webpackChunkName: 'AddClosedAlertIDUseCase' */
  './alert/UseCases/AddClosedAlertIDUseCase.js'), 'AddClosedAlertIDUseCase'),
  GetUserAlertUseCase: interOP(() => import(
  /* webpackChunkName: 'GetUserAlertUseCase' */
  './alert/UseCases/GetUserAlertUseCase.js'), 'GetUserAlertUseCase'),
  GetPromotionCodeAlertUseCase: interOP(() => import(
  /* webpackChunkName: 'GetPromotionCodeAlertUseCase' */
  './alert/UseCases/GetPromotionCodeAlertUseCase.js'), 'GetPromotionCodeAlertUseCase'),

  /* Blog */
  GetAllBlogUseCase: interOP(() => import(
  /* webpackChunkName: 'GetAllBlogUseCase' */
  './blog/UseCases/GetAllBlogUseCase.js'), 'GetAllBlogUseCase'),
  GetPostContentBlogUseCase: interOP(() => import(
  /* webpackChunkName: 'GetPostContentBlogUseCase' */
  './blog/UseCases/GetPostContentBlogUseCase.js'), 'GetPostContentBlogUseCase'),

  /* Follow */
  CreateDomestikaFollowUseCase: interOP(() => import(
  /* webpackChunkName: 'CreateDomestikaFollowUseCase' */
  './follow/UseCases/CreateDomestikaFollowUseCase.js'), 'CreateDomestikaFollowUseCase'),
  DeleteFollowUseCase: interOP(() => import(
  /* webpackChunkName: 'DeleteFollowUseCase' */
  './follow/UseCases/DeleteFollowUseCase.js'), 'DeleteFollowUseCase'),

  /* Tracking */
  SendTrackingUseCase: interOP(() => import(
  /* webpackChunkName: 'SendTrackingUseCase' */
  './tracking/UseCases/SendTrackingUseCase.js'), 'SendTrackingUseCase'),
  SendPlayerTrackingUseCase: interOP(() => import(
  /* webpackChunkName: 'SendPlayerTrackingUseCase' */
  './tracking/UseCases/SendPlayerTrackingUseCase.js'), 'SendPlayerTrackingUseCase'),
  ViewPageTrackingUseCase: interOP(() => import(
  /* webpackChunkName: 'ViewPageTrackingUseCase' */
  './tracking/UseCases/ViewPageTrackingUseCase.js'), 'ViewPageTrackingUseCase'),
  SendHeaderTrackingUseCase: interOP(() => import(
  /* webpackChunkName: 'SendHeaderTrackingUseCase' */
  './tracking/UseCases/SendHeaderTrackingUseCase.js'), 'SendHeaderTrackingUseCase'),

  /* User */
  CreateJWTUserUseCase: interOP(() => import(
  /* webpackChunkName: 'CreateJWTUserUseCase' */
  './user/UseCases/CreateJWTUserUseCase.js'), 'CreateJWTUserUseCase'),
  CurrentWithoutRelationshipsUserUseCase: interOP(() => import(
  /* webpackChunkName: 'CurrentWithoutRelationshipsUserUseCase' */
  './user/UseCases/CurrentWithoutRelationshipsUserUseCase'), 'CurrentWithoutRelationshipsUserUseCase'),
  CurrentUserUseCase: interOP(() => import(
  /* webpackChunkName: 'CurrentUserUseCase' */
  './user/UseCases/CurrentUserUseCase.js'), 'CurrentUserUseCase'),
  GetSimpleUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetSimpleUserUseCase' */
  './user/UseCases/GetSimpleUserUseCase.js'), 'GetSimpleUserUseCase'),
  GetSessionDataUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetSessionDataUserUseCase' */
  './user/UseCases/GetSessionDataUserUseCase.js'), 'GetSessionDataUserUseCase'),
  GetAccessTokenUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetAccessTokenUserUseCase' */
  './user/UseCases/GetAccessTokenUserUseCase.js'), 'GetAccessTokenUserUseCase'),
  RefreshAccessTokenUserUseCase: interOP(() => import(
  /* webpackChunkName: 'RefreshAccessTokenUserUseCase' */
  './user/UseCases/RefreshAccessTokenUserUseCase.js'), 'RefreshAccessTokenUserUseCase'),
  RemoveAccessTokenUserUseCase: interOP(() => import(
  /* webpackChunkName: 'RemoveAccessTokenUserUseCase' */
  './user/UseCases/RemoveAccessTokenUserUseCase.js'), 'RemoveAccessTokenUserUseCase'),
  UpdateLanguageUserUseCase: interOP(() => import(
  /* webpackChunkName: 'UpdateLanguageUserUseCase' */
  './user/UseCases/UpdateLanguageUserUseCase.js'), 'UpdateLanguageUserUseCase'),
  LogoutUserUseCase: interOP(() => import(
  /* webpackChunkName: 'LogoutUserUseCase' */
  './user/UseCases/LogoutUserUseCase.js'), 'LogoutUserUseCase'),
  SetGDPRStatusUserUseCase: interOP(() => import(
  /* webpackChunkName: 'SetGDPRStatusUserUseCase' */
  './user/UseCases/SetGDPRStatusUserUseCase.js'), 'SetGDPRStatusUserUseCase'),
  GetGDPRStatusUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetGDPRStatusUserUseCase' */
  './user/UseCases/GetGDPRStatusUserUseCase.js'), 'GetGDPRStatusUserUseCase'),
  SetAdvanceGDPRStatusUserUseCase: interOP(() => import(
  /* webpackChunkName: 'SetAdvanceGDPRStatusUserUseCase' */
  './user/UseCases/SetAdvanceGDPRStatusUserUseCase.js'), 'SetAdvanceGDPRStatusUserUseCase'),
  GetAdvanceGDPRStatusUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetAdvanceGDPRStatusUserUseCase' */
  './user/UseCases/GetAdvanceGDPRStatusUserUseCase.js'), 'GetAdvanceGDPRStatusUserUseCase'),
  SetVideoVolumeUserUseCase: interOP(() => import(
  /* webpackChunkName: 'SetVideoVolumeUserUseCase' */
  './user/UseCases/SetVideoVolumeUserUseCase.js'), 'SetVideoVolumeUserUseCase'),
  GetVideoVolumeUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetVideoVolumeUserUseCase' */
  './user/UseCases/GetVideoVolumeUserUseCase.js'), 'GetVideoVolumeUserUseCase'),
  SetVideoSpeedUserUseCase: interOP(() => import(
  /* webpackChunkName: 'SetVideoSpeedUserUseCase' */
  './user/UseCases/SetVideoSpeedUserUseCase.js'), 'SetVideoSpeedUserUseCase'),
  GetVideoSpeedUserUseCase: interOP(() => import(
  /* webpackChunkName: 'GetVideoSpeedUserUseCase' */
  './user/UseCases/GetVideoSpeedUserUseCase.js'), 'GetVideoSpeedUserUseCase'),

  /* Course */
  GetCategoriesCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetCategoriesCourseUseCase' */
  './course/UseCases/GetCategoriesCourseUseCase.js'), 'GetCategoriesCourseUseCase'),
  GetAreasCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetAreasCourseUseCase' */
  './course/UseCases/GetAreasCourseUseCase.js'), 'GetAreasCourseUseCase'),
  GetSoftwaresCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetSoftwaresCourseUseCase' */
  './course/UseCases/GetSoftwaresCourseUseCase.js'), 'GetSoftwaresCourseUseCase'),
  GetCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetCourseUseCase' */
  './course/UseCases/GetCourseUseCase.js'), 'GetCourseUseCase'),
  SearchCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'SearchCourseUseCase' */
  './course/UseCases/SearchCourseUseCase.js'), 'SearchCourseUseCase'),
  GetCartCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetCartCourseUseCase' */
  './course/UseCases/GetCartCourseUseCase.js'), 'GetCartCourseUseCase'),
  GetFinalProjectVideoByCourseIDCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetFinalProjectVideoByCourseIDCourseUseCase' */
  './course/UseCases/GetFinalProjectVideoByCourseIDCourseUseCase.js'), 'GetFinalProjectVideoByCourseIDCourseUseCase'),
  GetVideoProgressListCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'GetVideoProgressListCourseUseCase' */
  './course/UseCases/GetVideoProgressListCourseUseCase.js'), 'GetVideoProgressListCourseUseCase'),
  SendVideoProgressCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'SendVideoProgressCourseUseCase' */
  './course/UseCases/SendVideoProgressCourseUseCase.js'), 'SendVideoProgressCourseUseCase'),
  UpdateVideoProgressCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'UpdateVideoProgressCourseUseCase' */
  './course/UseCases/UpdateVideoProgressCourseUseCase.js'), 'UpdateVideoProgressCourseUseCase'),
  UpdateVideoAudioAndSubtitlesCourseUseCase: interOP(() => import(
  /* webpackChunkName: 'UpdateVideoAudioAndSubtitlesCourseUseCase' */
  './course/UseCases/UpdateVideoAudioAndSubtitlesCourseUseCase.js'), 'UpdateVideoAudioAndSubtitlesCourseUseCase'),

  /* Credential */
  GetPubnubCredentialsUseCase: interOP(() => import(
  /* webpackChunkName: 'GetPubnubCredentialsUseCase' */
  './credential/UseCases/GetPubnubCredentialsUseCase.js'), 'GetPubnubCredentialsUseCase'),

  /* Promotion */
  GetPromotionUseCase: interOP(() => import(
  /* webpackChunkName: 'GetPromotionUseCase' */
  './promotion/UseCases/GetPromotionUseCase.js'), 'GetPromotionUseCase'),
  GetPlusPromotionUseCase: interOP(() => import(
  /* webpackChunkName: 'GetPlusPromotionUseCase' */
  './promotion/UseCases/GetPlusPromotionUseCase.js'), 'GetPlusPromotionUseCase'),

  /* Organization */
  GetOrganizationUseCase: interOP(() => import(
  /* webpackChunkName: 'GetOrganizationUseCase' */
  './organization/UseCases/GetOrganizationUseCase.js'), 'GetOrganizationUseCase'),

  /* LiveSession */
  GetLiveSessionUseCase: interOP(() => import(
  /* webpackChunkName: 'GetLiveSessionUseCase' */
  './liveSession/UseCases/GetLiveSessionUseCase.js'), 'GetLiveSessionUseCase'),
  GetListLiveSessionUseCase: interOP(() => import(
  /* webpackChunkName: 'GetListLiveSessionUseCase' */
  './liveSession/UseCases/GetListLiveSessionUseCase.js'), 'GetListLiveSessionUseCase'),
  UpdateLiveSessionUseCase: interOP(() => import(
  /* webpackChunkName: 'UpdateLiveSessionUseCase' */
  './liveSession/UseCases/UpdateLiveSessionUseCase.js'), 'UpdateLiveSessionUseCase'),

  /* LiveStream */
  GetListLiveStreamUseCase: interOP(() => import(
  /* webpackChunkName: 'GetListLiveStreamUseCase' */
  './liveStream/UseCases/GetListLiveStreamUseCase.js'), 'GetListLiveStreamUseCase'),

  /* LiveChannel */
  GetLiveChannelUseCase: interOP(() => import(
  /* webpackChunkName: 'GetLiveChannelUseCase' */
  './liveChannel/UseCases/GetLiveChannelUseCase.js'), 'GetLiveChannelUseCase'),

  /* Device */
  CreateDeviceUseCase: interOP(() => import(
  /* webpackChunkName: 'CreateDeviceUseCase' */
  './device/UseCases/CreateDeviceUseCase.js'), 'CreateDeviceUseCase'),
  DeleteDeviceUseCase: interOP(() => import(
  /* webpackChunkName: 'DeleteDeviceUseCase' */
  './device/UseCases/DeleteDeviceUseCase.js'), 'DeleteDeviceUseCase'),

  /* LiveFeedbackQuestion */
  GetListLiveFeedbackQuestionUseCase: interOP(() => import(
  /* webpackChunkName: 'GetListLiveFeedbackQuestionUseCase' */
  './liveFeedbackQuestion/UseCases/GetListLiveFeedbackQuestionUseCase'), 'GetListLiveFeedbackQuestionUseCase'),

  /* LiveFeedbackAnswer */
  SendLiveFeedbackAnswersUseCase: interOP(() => import(
  /* webpackChunkName: 'SendLiveFeedbackAnswersUseCase' */
  './liveFeedbackAnswer/UseCases/SendLiveFeedbackAnswersUseCase'), 'SendLiveFeedbackAnswersUseCase'),

  /* UserLiveSession */
  CreateUserLiveSessionUseCase: interOP(() => import(
  /* webpackChunkName: 'CreateUserLiveSessionUseCase' */
  './userLiveSession/UseCases/CreateUserLiveSessionUseCase.js'), 'CreateUserLiveSessionUseCase'),
  FinishUserLiveSessionUseCase: interOP(() => import(
  /* webpackChunkName: 'FinishUserLiveSessionUseCase' */
  './userLiveSession/UseCases/FinishUserLiveSessionUseCase.js'), 'FinishUserLiveSessionUseCase')
};
export class Domestika {
  static async create(externalConfig) {
    const config = await Config.create(externalConfig);
    return new Domestika({
      config
    });
  }

  constructor(_ref) {
    let {
      config
    } = _ref;
    this._config = void 0;
    this._config = config;
  }

  config(key, value) {
    return value ? this._config.set(key, value) : this._config.get(key);
  }
  /* Alert */


  get AddClosedAlertIDUseCase() {
    return this._getter('AddClosedAlertIDUseCase');
  }

  get GetUserAlertUseCase() {
    return this._getter('GetUserAlertUseCase');
  }

  get GetPromotionCodeAlertUseCase() {
    return this._getter('GetPromotionCodeAlertUseCase');
  }
  /* Blogs */


  get GetAllBlogUseCase() {
    return this._getter('GetAllBlogUseCase');
  }

  get GetPostContentBlogUseCase() {
    return this._getter('GetPostContentBlogUseCase');
  }
  /* Follow */


  get CreateDomestikaFollowUseCase() {
    return this._getter('CreateDomestikaFollowUseCase');
  }

  get DeleteFollowUseCase() {
    return this._getter('DeleteFollowUseCase');
  }
  /* Tracking */


  get SendPlayerTrackingUseCase() {
    return this._getter('SendPlayerTrackingUseCase');
  }

  get SendTrackingUseCase() {
    return this._getter('SendTrackingUseCase');
  }

  get ViewPageTrackingUseCase() {
    return this._getter('ViewPageTrackingUseCase');
  }

  get SendHeaderTrackingUseCase() {
    return this._getter('SendHeaderTrackingUseCase');
  }
  /* Users */


  get CreateJWTUserUseCase() {
    return this._getter('CreateJWTUserUseCase');
  }

  get CurrentWithoutRelationshipsUserUseCase() {
    return this._getter('CurrentWithoutRelationshipsUserUseCase');
  }

  get CurrentUserUseCase() {
    return this._getter('CurrentUserUseCase');
  }

  get GetSimpleUserUseCase() {
    return this._getter('GetSimpleUserUseCase');
  }

  get GetSessionDataUserUseCase() {
    return this._getter('GetSessionDataUserUseCase');
  }

  get GetAccessTokenUserUseCase() {
    return this._getter('GetAccessTokenUserUseCase');
  }

  get RefreshAccessTokenUserUseCase() {
    return this._getter('RefreshAccessTokenUserUseCase');
  }

  get RemoveAccessTokenUserUseCase() {
    return this._getter('RemoveAccessTokenUserUseCase');
  }

  get UpdateLanguageUserUseCase() {
    return this._getter('UpdateLanguageUserUseCase');
  }

  get LogoutUserUseCase() {
    return this._getter('LogoutUserUseCase');
  }

  get SetGDPRStatusUserUseCase() {
    return this._getter('SetGDPRStatusUserUseCase');
  }

  get GetGDPRStatusUserUseCase() {
    return this._getter('GetGDPRStatusUserUseCase');
  }

  get SetAdvanceGDPRStatusUserUseCase() {
    return this._getter('SetAdvanceGDPRStatusUserUseCase');
  }

  get GetAdvanceGDPRStatusUserUseCase() {
    return this._getter('GetAdvanceGDPRStatusUserUseCase');
  }

  get SetVideoVolumeUserUseCase() {
    return this._getter('SetVideoVolumeUserUseCase');
  }

  get GetVideoVolumeUserUseCase() {
    return this._getter('GetVideoVolumeUserUseCase');
  }

  get SetVideoSpeedUserUseCase() {
    return this._getter('SetVideoSpeedUserUseCase');
  }

  get GetVideoSpeedUserUseCase() {
    return this._getter('GetVideoSpeedUserUseCase');
  }
  /* Course */


  get GetCategoriesCourseUseCase() {
    return this._getter('GetCategoriesCourseUseCase');
  }

  get GetAreasCourseUseCase() {
    return this._getter('GetAreasCourseUseCase');
  }

  get GetSoftwaresCourseUseCase() {
    return this._getter('GetSoftwaresCourseUseCase');
  }

  get GetCourseUseCase() {
    return this._getter('GetCourseUseCase');
  }

  get SearchCourseUseCase() {
    return this._getter('SearchCourseUseCase');
  }

  get GetCartCourseUseCase() {
    return this._getter('GetCartCourseUseCase');
  }

  get GetFinalProjectVideoByCourseIDCourseUseCase() {
    return this._getter('GetFinalProjectVideoByCourseIDCourseUseCase');
  }

  get GetVideoProgressListCourseUseCase() {
    return this._getter('GetVideoProgressListCourseUseCase');
  }

  get SendVideoProgressCourseUseCase() {
    return this._getter('SendVideoProgressCourseUseCase');
  }

  get UpdateVideoProgressCourseUseCase() {
    return this._getter('UpdateVideoProgressCourseUseCase');
  }

  get UpdateVideoAudioAndSubtitlesCourseUseCase() {
    return this._getter('UpdateVideoAudioAndSubtitlesCourseUseCase');
  }
  /* Credential */


  get GetPubnubCredentialsUseCase() {
    return this._getter('GetPubnubCredentialsUseCase');
  }
  /* Promotion */


  get GetPromotionUseCase() {
    return this._getter('GetPromotionUseCase');
  }

  get GetPlusPromotionUseCase() {
    return this._getter('GetPlusPromotionUseCase');
  }
  /* Organization */


  get GetOrganizationUseCase() {
    return this._getter('GetOrganizationUseCase');
  }
  /* LiveStream */


  get GetListLiveStreamUseCase() {
    return this._getter('GetListLiveStreamUseCase');
  }
  /* LiveSession */


  get GetLiveSessionUseCase() {
    return this._getter('GetLiveSessionUseCase');
  }

  get GetListLiveSessionUseCase() {
    return this._getter('GetListLiveSessionUseCase');
  }

  get UpdateLiveSessionUseCase() {
    return this._getter('UpdateLiveSessionUseCase');
  }
  /* LiveChannel */


  get GetLiveChannelUseCase() {
    return this._getter('GetLiveChannelUseCase');
  }
  /* Device */


  get CreateDeviceUseCase() {
    return this._getter('CreateDeviceUseCase');
  }

  get DeleteDeviceUseCase() {
    return this._getter('DeleteDeviceUseCase');
  }
  /* LiveFeedbackQuestion */


  get GetListLiveFeedbackQuestionUseCase() {
    return this._getter('GetListLiveFeedbackQuestionUseCase');
  }
  /* LiveFeedbackAnswer */


  get SendLiveFeedbackAnswersUseCase() {
    return this._getter('SendLiveFeedbackAnswersUseCase');
  }
  /* UserLiveSession */


  get CreateUserLiveSessionUseCase() {
    return this._getter('CreateUserLiveSessionUseCase');
  }

  get FinishUserLiveSessionUseCase() {
    return this._getter('FinishUserLiveSessionUseCase');
  }

  _getter(name) {
    const self = this;
    return {
      async execute() {
        const klass = await UseCases[name]();
        const response = klass.create({
          config: self._config
        }).execute(...arguments);
        return response;
      }

    };
  }

}